<script>
import AdditionalActions from "@/components/actions/AdditionalActions.vue";
import BaseView from "@/views/BaseView.vue";
import { DispatcherPermissionValue } from "@/api/dto/dispatcher.dto.ts";

export default {
  name: "TruckAdditionalActions",
  components: { AdditionalActions },
  mixins: [BaseView],
  props: {
    truck: {
      type: Object,
      required: true,
    },
  },
  emits: ["change"],
  computed: {
    hasAccessToArchive() {
      return this.hasAccess(DispatcherPermissionValue.ArchiveTruck);
    },
  },
  methods: {
    async archive(onSuccess, onError) {
      const resp = await this.$api.trucks.archiveTruck(this.truck.id);
      if (resp.success) {
        onSuccess();
        this.$emit("change");
      } else {
        onError("The truck can’t be archived due to reasons:", resp.data?.detail);
      }
    },
    async unarchive(onSuccess, onError) {
      const resp = await this.$api.trucks.unarchiveTruck(this.truck.id);
      if (resp.success) {
        onSuccess();
        this.$emit("change");
      } else {
        onError("The truck can’t be unarchived due to reasons:", resp.data?.detail);
      }
    },
  },
};
</script>

<template>
  <additional-actions
    :archive-confirmation-text="'Are you sure want to send truck ' + truck.number + ' to archive?'"
    :has-access="hasAccessToArchive"
    :is-archived="truck.archived"
    :permission-text="$t('permission.archive-truck')"
    :unarchive-confirmation-text="'Are you sure want to return truck ' + truck.number + ' from archive?'"
    archive-confirmation-title="Archive truck"
    unarchive-confirmation-title="Unarchive truck"
    @archive="archive"
    @unarchive="unarchive"
  ></additional-actions>
</template>

<style lang="scss" scoped></style>
